import "../sass/main.scss";
import React, { useCallback, useMemo, useState } from "react";
import ventures from "../static/data/journeys.js";
import IndiaImg from "../static/images/sheVentures/india.jpg";
import BhutanImg from "../static/images/sheVentures/bhutan.jpg";
import SriLankaImg from "../static/images/sheVentures/sriLanka.jpg";
import { useNavigate } from "react-router-dom";
import AnimatedContent from "../animatedComponents/AnimatedContent.js";
import useWindowDimensions from "../hooks/useWindowDimensions.js";
import LazyImage from "../components/LazyImage.js";

const IMAGES = {
  India: IndiaImg,
  Bhutan: BhutanImg,
  SriLanka: SriLankaImg,
};

const ALL_COUNTRIES = ["India", "Bhutan", "SriLanka"];

export const SheVentures = () => {
  const [currentCountry, setCurrentCountry] = useState("India");
  const [showCardDetails, setShowCardDetails] = useState(false);
  const navigate = useNavigate();
  const [addDesktopHoverStyles, setAddDesktopHoverStyles] = useState(false);
  const { width } = useWindowDimensions();

  // Derive remaining countries for the small cards
  const otherCountries = useMemo(() => {
    return ALL_COUNTRIES.filter((country) => country !== currentCountry);
  }, [currentCountry]);

  // When user clicks one of the small images, update main and rotate
  const handleCountryClick = useCallback(
    (newCountry) => {
      setCurrentCountry(newCountry);
      setShowCardDetails(prevState => !prevState)
    },
    []
  );

  const currentDetails = useMemo(() => ventures.filter(venture => venture.country === currentCountry)[0].details[0], [currentCountry]);

  const goToCountry = useCallback(() => {
    navigate(`/:${currentCountry}`);
  }, [currentCountry, navigate]);



  const renderMobileView = useMemo(() => {
    if (width > 600) return null;
    return (
      <>
        <h1>Destinations</h1>
        <div className="signature-journeys-container" style={{
          height: "65vh",
          cursor: "pointer",
        }}>
          <div className="sj-card-container" style={{ marginTop: 0, paddingBottom: 0, overflowY: "hidden", height: "100%" }} id="scrollbar-style">
            {ALL_COUNTRIES.map((country, index) => {
              return (
                <div
                  key={country}
                  className="ventures-small-card"
                  style={{
                    margin: index % 2 === 0 ? "00 0 0 0" : "0rem 1.5rem 0 1.5rem",

                  }}
                  onClick={() => handleCountryClick(country)}
                >
                  {currentCountry === country && showCardDetails ? (
                    <div style={{
                      width: "80vw",
                      height: "100%",
                      borderRadius: "1rem",
                    }}>
                      <div className="ventures-description-container" style={{
                        backgroundColor: "#97789b",
                        padding: "2rem",
                        height: "60vh",
                        borderRadius: "1rem",
                        boxShadow: "0 0.5rem 0.5rem rgba(0, 0, 0, 0.2)"
                      }}>
                        <p className="ventures-p" style={{ color: "#fff", fontSize: "1rem" }}>
                          {currentDetails}
                        </p>
                        <button className="button-greyish" style={{ marginTop: "2rem" }} onClick={goToCountry}>
                          {currentCountry === "SriLanka" ? "SRI LANKA" : currentCountry.toUpperCase()}
                        </button>
                      </div>
                    </div>
                  )
                    :
                    (
                      <LazyImage
                        imgOnly
                        src={IMAGES[country]}
                        alt={currentCountry}
                        className="ventures-main-img"
                        styleish={{
                          boxShadow: "0 0.5rem 0.5rem rgba(0, 0, 0, 0.2)",
                          maxHeight: "60vh"
                        }}
                      />
                    )
                  }
                  {!showCardDetails && <div className="ventures-main-title">{country}</div>}
                </div>
              )
            })}

          </div>

        </div>
      </>
    )
  }, [currentCountry, currentDetails, goToCountry, handleCountryClick, showCardDetails, width]);

  const renderDesktopLeftView = useMemo(() => {
    if (width < 600) return null;
    return (
      <>
        <LazyImage
          imgOnly={true}
          src={IMAGES[currentCountry]}
          alt={currentCountry}
          className="ventures-main-img"
        />
        <div className="ventures-main-title">{currentCountry === "SriLanka" ? "Sri Lanka" : currentCountry}</div>
      </>
    )
  }, [currentCountry, width]);

  const addHoverStyle = useMemo(() => {
    if (width < 600) return null;
    console.log("Sending these")
    if (addDesktopHoverStyles) {
      return {
        boxShadow: "4px 4px 10px rgba(0, 0, 0, 0.45)",
        border: "2px solid #97789b",
        borderRadius: "1rem",
      }
    } else return;
  }, [addDesktopHoverStyles, width]);



  return (
    <div className="ventures-new-layout">
      <div
        onMouseEnter={() => setAddDesktopHoverStyles(true)}
        onMouseLeave={() => setAddDesktopHoverStyles(false)}
        className="ventures-new-left"
        style={addHoverStyle}
      >
        {renderMobileView}
        {renderDesktopLeftView}
      </div>

      <div className="ventures-new-right">

        {width > 600 && (
          <AnimatedContent className="ventures-small-images">
            {otherCountries.map((country) => (
              <div
                key={country}
                className="ventures-small-card"
                onClick={() => handleCountryClick(country)}
              >
                <LazyImage imgOnly src={IMAGES[country]} alt={country} />
                <span>{country === "SriLanka" ? "Sri Lanka" : country}</span>
              </div>
            ))}
          </AnimatedContent>
        )
        }

        {
          width > 600 && (
            <div className="ventures-text-container">
              <h1>Destinations</h1>

              <div className="ventures-description-container">
                <p className="ventures-p">
                  {currentDetails}
                </p>
              </div>
              <div>
                <button className="button-greyish" style={{}} onClick={goToCountry}>
                  {currentCountry === "SriLanka" ? "SRI LANKA" : currentCountry.toUpperCase()}
                </button>
              </div>

            </div>
          )
        }
      </div>
    </div>
  );
};
